import React from "react";
import SignUpForm from "../../components/signUpForm/signUpForm.comp";
import "./signIn.style.scss";

const SignIn = () => {
    return (
        <div>
            <SignUpForm/>
        </div>
    );
};

export default SignIn;